import { environment } from '../../../environments/environment';

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

const INIT_FLAG = '__launchpocketGtagInitialized';

function isValidMeasurementId(raw: string): boolean {
  const id = raw.trim();
  return id.length > 0 && /^G-[A-Z0-9]+$/i.test(id);
}

/**
 * Loads gtag.js for the configured GA4 measurement ID.
 * `gtag('js', …)` and `gtag('config', …)` run only after the script `load` event so the library is ready before /g/collect.
 */
export function initializeGoogleAnalytics(): void {
  const raw = environment.gaId;
  if (typeof raw !== 'string' || !isValidMeasurementId(raw)) {
    return;
  }

  const id = raw.trim();
  const w = window as Window & { [INIT_FLAG]?: boolean };

  if (w[INIT_FLAG]) {
    return;
  }
  w[INIT_FLAG] = true;

  w.dataLayer = w.dataLayer ?? [];
  w.gtag = function gtag(): void {
    w.dataLayer!.push(arguments);
  };

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`;
  script.onload = (): void => {
    const gtag = w.gtag;
    if (!gtag) {
      return;
    }
    gtag('js', new Date());
    const config: Record<string, boolean> = { send_page_view: true };
    if (!environment.production) {
      config['debug_mode'] = true;
    }
    gtag('config', id, config);
  };
  document.head.appendChild(script);
}
